<template>
  <div class="form-group">
    <label :class="{ 'text-danger': error }">Supercliente</label>
    <v-select
      label="nombre"
      :value="value"
      :disabled="disabled || !tienda"
      :filterable="false"
      :options="opciones"
      @input="onInput"
      @search="onSearch"
    >
      <template slot="no-options">
        {{ tienda ? "Buscar por código, nombre o NIT..." : "Seleccione la tienda" }}
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          <b>{{ option.codigo }}</b> - {{ option.nombre }}
          <small class="d-block text-muted">NIT: {{ option.nit || "-" }}</small>
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.codigo }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small v-if="tienda" class="form-text text-muted">
      Solo superclientes creados en la tienda {{ tienda }}.
    </small>
    <small v-if="error" class="form-text text-danger">{{ error }}</small>
  </div>
</template>

<script>
import _ from "lodash";
import DynamicService from "@/services/commons/DynamicService";

/**
 * Selector de supercliente para cotizaciones de requerimiento.
 * Busca por codigo, nombre o NIT en cat_super_cliente, solo entre los
 * superclientes creados en la tienda indicada (codigo CL{tienda}NNNNNN).
 * Emite "input" con el supercliente seleccionado ({ codigo, nombre, nit, direccion }) o null.
 */
export default {
  name: "SuperClienteTiendaSelectComponent",
  props: ["value", "tienda", "disabled", "error"],
  data() {
    return {
      opciones: [],
    };
  },
  watch: {
    tienda() {
      this.opciones = [];
    },
  },
  methods: {
    onInput(superCliente) {
      this.$emit("input", superCliente || null);
    },
    onSearch(texto, loading) {
      if (!texto || !this.tienda) {
        return;
      }
      loading(true);
      this.buscar(loading, texto, this);
    },
    buscar: _.debounce((loading, texto, vm) => {
      const tienda = vm.tienda;
      DynamicService.fetch("cat", "super-cliente", {
        page: 1,
        tienda_prefijo: tienda,
        "filter[search]": texto,
      })
        .then((response) => {
          if (vm.tienda !== tienda) {
            return;
          }
          const data = response.data;
          vm.opciones = Array.isArray(data) ? data : data.results || [];
        })
        .catch(() => {
          vm.opciones = [];
        })
        .finally(() => {
          loading(false);
        });
    }, 350),
  },
};
</script>
